import { useEffect } from "react";
import { supabase } from "@/lib/supabase";
import { initGA } from "@/lib/ga";

/** Loads ga_measurement_id from public site_settings and initializes gtag. */
const GAInit = () => {
  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data } = await supabase
          .from("site_settings")
          .select("value")
          .eq("key", "ga_measurement_id")
          .maybeSingle();
        if (cancelled) return;
        initGA(data?.value ?? null);
      } catch {
        initGA(null); // fallback to default
      }
    })();
    return () => { cancelled = true; };
  }, []);
  return null;
};

export default GAInit;
